export default function init_menu(IconsView, iconsViewCache) {

    IconsView.prototype.createMenu = function (datas, icon) {
        const myself = this;
        let menu = $('.menu--context');
        if (!menu.length) {
            $('body').append('<div class="menu menu--context"><div class="menu__content"><div class="menu__inner"></div></div></div>');
            menu = $('.menu--context');
            $('body').on('contextmenu', () => {
                if ($('.menu--context').hasClass('menu--open')) {
                    myself.element.find('.iv__item--context').removeClass('iv__item--context');
                    $('.menu--context').removeClass('menu--open');
                    return false;
                }

                return true;
            });
            $('body').click(() => {
                $('.menu--context').removeClass('menu--open');
                myself.element.find('.iv__item--context').removeClass('iv__item--context');
            });
        }
        menu.addClass('menu--open');
        myself.element.find('.iv__item--context').removeClass('iv__item--context');
        if (icon) icon.addClass('iv__item--context');

        menu.find('.menu__inner').html('');
        const menuList = $('<ul class="menu__list"></ul>');
        menu.find('.menu__inner').append(menuList);

        myself.createMenuItems(datas, menuList, icon);

        imgToSvg($('.menu--context'));

        // Position with boundary detection
        let top = mouseY;
        let left = mouseX;

        const menuWidth = menu.outerWidth();
        const menuHeight = menu.outerHeight();
        const windowWidth = $(window).width();
        const windowHeight = $(window).height();
        const scrollLeft = $(window).scrollLeft();
        const scrollTop = $(window).scrollTop();

        // Horizontal boundary
        if (left + menuWidth > windowWidth + scrollLeft) {
            left = mouseX - menuWidth;
        }

        // Vertical boundary
        if (top + menuHeight > windowHeight + scrollTop) {
            top = mouseY - menuHeight;
        }

        // Safety check
        if (left < scrollLeft) left = scrollLeft;
        if (top < scrollTop) top = scrollTop;

        menu.css('top', top).css('left', left);
    }


    IconsView.prototype.createMenuItems = function (datas, menuList, icon) {
        const myself = this;
        const menu = $('.menu--context');
        $.each(datas, (index, data) => {
            var item = '';
            if (data == '-') {
                var item = $(`
                    <li class="menu__item menu__item--separator"><span class="menu__line"></span></li>
                    `);
            } else {
                var item = $(`
                    <li class="menu__item">
                        <div class="menu__link"><span class="menu__icon">` + myself.renderIconImage(16, data.icon, data, 'img') + '</span><span class="menu__label">' + data.name + `</span></div>
                    </li>
                    `);
            }
            menuList.append(item);
            if (data != '-') {
                item.click((event) => {
                    menu.removeClass('menu--open');
                    myself.element.find('.iv__item--context').removeClass('iv__item--context');
                    // console.log(icon);
                    if (data.callback) data.callback(icon);
                    event.stopPropagation();
                });
                if (data.items) {
                    item.addClass('menu__item--parent');
                    const subList = $('<ul class="menu__list"></ul>');
                    item.append(subList);
                    myself.createMenuItems(data.items, subList, icon);

                    item.on('mouseenter', function () {
                        const sub = $(this).find('> .menu__list');
                        const subWidth = sub.outerWidth();
                        const subHeight = sub.outerHeight();
                        const offset = $(this).offset();
                        const windowWidth = $(window).width();
                        const windowHeight = $(window).height();
                        const scrollLeft = $(window).scrollLeft();
                        const scrollTop = $(window).scrollTop();

                        // Horizontal flip
                        if (offset.left + $(this).outerWidth() + subWidth > windowWidth + scrollLeft) {
                            sub.css('left', 'auto').css('right', '100%');
                        } else {
                            sub.css('left', '100%').css('right', 'auto');
                        }

                        // Vertical flip
                        if (offset.top + subHeight > windowHeight + scrollTop) {
                            sub.css('top', 'auto').css('bottom', '0');
                            // Safety if sub-menu is taller than window
                            const newOffsetTop = offset.top + $(this).outerHeight() - subHeight;
                            if (newOffsetTop < scrollTop) {
                                sub.css('top', (scrollTop - offset.top) + 'px').css('bottom', 'auto');
                            }
                        } else {
                            sub.css('top', '0').css('bottom', 'auto');
                        }
                    });
                }
            }
        });
    };

    IconsView.prototype.getAllowedModes = function () {
        let modes = null;

        // 1. Data attributes on element (dynamically updatable)
        if (this.element && this.element.length) {
            const dataModes = this.element.data('modes') !== undefined ? this.element.data('modes') : this.element.data('views');
            if (dataModes !== undefined && dataModes !== null && dataModes !== '') {
                if (Array.isArray(dataModes)) {
                    modes = dataModes;
                } else if (typeof dataModes === 'string') {
                    try {
                        const parsed = JSON.parse(dataModes);
                        if (Array.isArray(parsed)) modes = parsed;
                        else modes = dataModes.split(',').map(m => m.trim()).filter(Boolean);
                    } catch (e) {
                        modes = dataModes.split(',').map(m => m.trim()).filter(Boolean);
                    }
                }
            }
        }

        // 2. Instance property
        if (!modes && this.modes) {
            if (Array.isArray(this.modes)) {
                modes = this.modes;
            } else if (typeof this.modes === 'string') {
                modes = this.modes.split(',').map(m => m.trim()).filter(Boolean);
            }
        }

        // 3. Active template
        const activeTemplate = this.template || (this.templates && (this.templates[this.templateName] || this.templates[this.options && this.options.template] || this.templates.default));
        if (!modes && activeTemplate) {
            if (activeTemplate.view && Array.isArray(activeTemplate.view.modes) && activeTemplate.view.modes.length) {
                modes = activeTemplate.view.modes;
            } else if (activeTemplate.view && Array.isArray(activeTemplate.view.allowed_modes) && activeTemplate.view.allowed_modes.length) {
                modes = activeTemplate.view.allowed_modes;
            } else if (Array.isArray(activeTemplate.modes) && activeTemplate.modes.length) {
                modes = activeTemplate.modes;
            }
        }

        // 4. Options
        if (!modes && this.options) {
            if (Array.isArray(this.options.modes) && this.options.modes.length) {
                modes = this.options.modes;
            } else if (Array.isArray(this.options.views) && this.options.views.length) {
                modes = this.options.views;
            } else if (Array.isArray(this.options.allowedModes) && this.options.allowedModes.length) {
                modes = this.options.allowedModes;
            } else if (Array.isArray(this.options.allowedViews) && this.options.allowedViews.length) {
                modes = this.options.allowedViews;
            }
        }

        // 5. Conf
        if (!modes && this.conf) {
            if (Array.isArray(this.conf.modes) && this.conf.modes.length) {
                modes = this.conf.modes;
            } else if (Array.isArray(this.conf.views) && this.conf.views.length) {
                modes = this.conf.views;
            }
        }

        return modes;
    };

    IconsView.prototype.buildGlobalMenu = function () {
        const myself = this;
        const globalMenu = {};

        // 1. Display (Affichage)
        const canChangeView = (
            !myself.options || (
                (myself.options.features ? myself.options.features.changeView !== false : true) &&
                (myself.options.features ? myself.options.features.display !== false : true) &&
                (myself.options.features ? myself.options.features.view !== false : true)
            )
        ) && (myself.element ? myself.element.data('change-view') !== false : true);

        if (canChangeView) {
            const allowedModes = myself.getAllowedModes();
            const displayItems = {};

            const viewDefinitions = {
                mosaic: { key: 'view_mosaic', name: 'Mosaïque', icon: 'fa-th', view: 'mosaic' },
                icons: { key: 'view_icons', name: 'Icônes', icon: 'fa-th-large', view: 'icons' },
                list: { key: 'view_list', name: 'Liste', icon: 'fa-list', view: 'list' },
                table: { key: 'view_table', name: 'Tableau', icon: 'fa-table', view: 'table' },
                tree: { key: 'view_tree', name: 'Arbre', icon: 'fa-sitemap', view: 'tree' },
                blocks: { key: 'view_blocks', name: 'Blocs', icon: 'fa-cubes', view: 'blocks' },
                thumbnails: { key: 'view_thumbs', name: 'Miniatures', icon: 'fa-images', view: 'thumbnails' },
                thumbs: { key: 'view_thumbs', name: 'Miniatures', icon: 'fa-images', view: 'thumbnails' },
                cards: { key: 'view_cards', name: 'Cartes', icon: 'fa-id-card', view: 'cards' },
                card: { key: 'view_cards', name: 'Cartes', icon: 'fa-id-card', view: 'cards' },
                summary: { key: 'view_summary', name: 'Résumé', icon: 'fa-file-alt', view: 'summary' },
                preview: { key: 'view_preview', name: 'Aperçu', icon: 'fa-eye', view: 'preview' },
                slideshow: { key: 'view_slideshow', name: 'Diaporama', icon: 'fa-film', view: 'slideshow' },
                calendar: { key: 'view_calendar', name: 'Calendrier (Mois)', icon: 'fa-calendar', view: 'calendar' },
                'calendar-week': { key: 'view_calendar_week', name: 'Calendrier (Semaine)', icon: 'fa-calendar', view: 'calendar-week' },
                'calendar-day': { key: 'view_calendar_day', name: 'Calendrier (Jour)', icon: 'fa-calendar', view: 'calendar-day' },
                kanban: { key: 'view_kanban', name: 'Kanban', icon: 'fa-columns', view: 'kanban' },
                timeline: { key: 'view_timeline', name: 'Chronologie', icon: 'fa-stream', view: 'timeline' },
                map: { key: 'view_map', name: 'Carte', icon: 'fa-map-marked-alt', view: 'map' },
            };

            const defaultViewOrder = [
                'mosaic', 'icons', 'list', 'table', 'tree', 'blocks',
                'thumbnails', 'cards', 'summary', 'preview', 'slideshow',
                'calendar', 'calendar-week', 'calendar-day',
                'kanban', 'timeline', 'map'
            ];

            let modesToDisplay = [];
            if (allowedModes && Array.isArray(allowedModes) && allowedModes.length) {
                allowedModes.forEach(mode => {
                    const norm = (mode === 'thumbs' ? 'thumbnails' : (mode === 'grid' ? 'mosaic' : mode));
                    if (norm === 'calendar') {
                        modesToDisplay.push('calendar');
                        if (allowedModes.includes('calendar-week')) modesToDisplay.push('calendar-week');
                        else if (!allowedModes.includes('calendar-week') && !allowedModes.includes('calendar-day')) {
                            modesToDisplay.push('calendar-week');
                            modesToDisplay.push('calendar-day');
                        }
                        if (allowedModes.includes('calendar-day') && !modesToDisplay.includes('calendar-day')) {
                            modesToDisplay.push('calendar-day');
                        }
                    } else if (viewDefinitions[norm] && !modesToDisplay.includes(norm)) {
                        modesToDisplay.push(norm);
                    }
                });
            } else if (allowedModes && Array.isArray(allowedModes) && allowedModes.length === 0) {
                modesToDisplay = [];
            } else {
                modesToDisplay = defaultViewOrder;
            }

            if (modesToDisplay.length > 0) {
                const hasAuto = (!myself.options || myself.options.showAuto !== false) &&
                                (!myself.template || !myself.template.view || myself.template.view.auto !== false) &&
                                modesToDisplay.length > 1;

                if (hasAuto) {
                    displayItems.view_auto = myself.menuOption('Automatique', 'fa-magic', { action: 'setView', view: 'auto' });
                    displayItems.sep = '-';
                }

                modesToDisplay.forEach(mode => {
                    const def = viewDefinitions[mode];
                    if (def && !displayItems[def.key]) {
                        displayItems[def.key] = myself.menuOption(def.name, def.icon, { action: 'setView', view: def.view });
                    }
                });

                globalMenu.display = {
                    name: 'Affichage',
                    icon: 'app',
                    items: displayItems,
                };
            }
        }

        // 2. Sort (Trier)
        const menuSortItems = [
            myself.menuOption('Nom', 'media-text', { action: 'sort', order: 'name' }),
        ];
        const tableSortColumns = typeof myself.getViewColumns === 'function' ? myself.getViewColumns('table') : null;
        if (tableSortColumns && tableSortColumns.length) {
            $.each(tableSortColumns, (indexView, column) => {
                const label = (column.label) ? column.label : '';
                if (column.type != 'action' && column.type != 'icon' && column.type != 'label') {
                    menuSortItems.push(myself.menuOption(column.label, 'media-text', {
                        action: 'sort',
                        order: column.name,
                        type: column.type,
                    }));
                }
            });
        }

        if (myself.options && myself.options.features && myself.options.features.reorganize) {
            globalMenu.sort = {
                name: 'Trier',
                icon: 'media-text',
                items: menuSortItems,
            };
        }

        // 3. Refresh (Actualiser)
        globalMenu.refresh = myself.menuOption('Actualiser', 'arrow-do-refresh', { action: 'reload' });

        myself.globalMenu = globalMenu;
        return globalMenu;
    };
}
